import type { DashboardSortState } from "~/providers/FilterProvider";
import { EventSortByEnum } from "~/types/event";
import type { IEventFilters } from "~/types/eventFilters";
import { MetricsScopeEnum } from "~/types/metrics";
import { SortOrderEnum } from "~/types/sort";
import { type EventTabParam, EventTagEnum } from "~/types/tag";

const defaultEventSortByTab: Record<EventTabParam, DashboardSortState> = {
  [EventTagEnum.ALL]: {
    sortBy: EventSortByEnum.VOLUME,
    sortOrder: SortOrderEnum.DESC,
  },
  [EventTagEnum.NEW]: {
    sortBy: EventSortByEnum.START_DATE,
    sortOrder: SortOrderEnum.DESC,
  },
  [EventTagEnum.ENDING_SOON]: {
    sortBy: EventSortByEnum.END_DATE,
    sortOrder: SortOrderEnum.ASC,
  },
};

export const getDefaultEventSort = (
  tab: EventTabParam = EventTagEnum.ALL
): DashboardSortState => defaultEventSortByTab[tab];

export const defaultActivityFilter: IEventFilters = {
  active: true,
  resolved: undefined,
  metricsScope: MetricsScopeEnum.Event,
};
